import { useState, useRef, useEffect } from 'react';
import { Collapsible } from '../collapsible';
import { Error } from '../error';
import { PatternInput } from './input/PatternInput';
import { ProxyInput } from './input/ProxyInput';
import { VisiterInput } from './input/VisiterInput';
import { StartUrlsInput } from './input/StartUrlsInput';
import { PriorityInput } from './input/PriorityInput';
import { CrawlOptionsInput } from './input/CrawlOptionsInput';
import { Inner } from './Inner';
import { Required } from './Required';
import { Optional } from './Optional';
import { paramsInputsStyle } from './shared';

export const RunCrawl = (props) => {
  const renderChildren = (params, onChange, setParams, errors) => {
    return (
      <div style={paramsInputsStyle}>
        <Required style={paramsInputsStyle} slim={props.hideAdvanced}>
          <PatternInput params={params} onChange={onChange} errors={errors} />
        </Required>

        <Optional style={paramsInputsStyle} hide={props.hideAdvanced}>
          <Collapsible label="Start URLs" value={params.startUrls}>
            <StartUrlsInput noLabel params={params} onChange={onChange} errors={errors} />
          </Collapsible>

          <Collapsible label="Crawl Rules" value={params.priority}>
            <PriorityInput params={params} onChange={onChange} errors={errors} />
          </Collapsible>

          <div style={{ display: 'flex', gap: 10 }}>
            <VisiterInput params={params} onChange={onChange} errors={errors} />
            <ProxyInput params={params} onChange={onChange} errors={errors} />
          </div>
          <div style={{ display: 'flex', gap: 10 }}>
            <CrawlOptionsInput params={params} onChange={onChange} errors={errors} />
          </div>
        </Optional>
      </div>
    );
  };

  const examples = [
    {
      name: 'pokemondb.net',
      params: {
        pattern: 'https://pokemondb.net/**',
        maxVisits: 200,
        concurrency: 50,
      },
    },
    {
      name: 'reddit.com',
      params: {
        pattern: 'https://www.reddit.com/r/*/comments/**',
        maxVisits: 200,
        concurrency: 50,
      },
    },
  ];

  return (
    <Inner
      endpoint="crawl"
      required={['pattern']}
      initialParams={props.params}
      examples={examples}
      renderChildren={renderChildren}
      {...props}
    />
  );
};
